import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CategoryList from "../../features/manageCategories/categoryList";
import CategoryTopbar from "../../features/manageCategories/topbar";
import { useEffect, useState } from "react";
import {
  useAddCategoryMutation,
  useLazyDeleteCategoryQuery,
  useLazyGetCategoryQuery,
  useUpdateCategoryMutation,
  useUpdateStatusMutation,
} from "../../services/category";
import { Category } from "../../types/General";
import AddCategory from "../../Modals/addCategory";
import { showError, showToast } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import usePermission from "../../hooks/usePermission";

const ManageCategories = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);




  const { isAdd, isDelete, isView } = usePermission({
    label: "Manage Categories",
    page_permission: "isView",
  });

  
  const [getCategory] = useLazyGetCategoryQuery();
  const [addCategory] = useAddCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();
  const [updateStatus] = useUpdateStatusMutation();
  const [deleteCategory] = useLazyDeleteCategoryQuery();

  const [open, setOpen] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [category, setCategory] = useState<Category[]>([]);
  const [count, setCount] = useState(0);
  const [categoryName, setCategoryName] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const handleCloseModal = () => {
    setCategoryName("");
    setOpen(false);
    setError(false);
  };

  const getAllCategory = async () => {
    setIsLoading(true);
    try {
      const response = await getCategory({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setCategory(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    setError(true);
    if (categoryName === "") {
    } else {
      const body = {
        categoryName,
        ...(selectedId ? { categoryId: selectedId || "" } : {}),
      };
      if (selectedId) {
        try {
          const response = await updateCategory(body).unwrap();

          if (response?.statusCode === 200) {
            showToast("Category updated successfully");
            setCategoryName("");
            setOpen(false);
            getAllCategory();
          }
        } catch (error: any) {
          setIsLoading(false);
        }
      } else {
        try {
          const response = await addCategory(body).unwrap();

          if (response?.statusCode === 200) {
            showToast("Category added successfully");
            setCategoryName("");
            setOpen(false);
            getAllCategory();
          }
        } catch (error: any) {
          setIsLoading(false);
        }
      }
    }
  };

  const handleDelete = async () => {
    setIsLoading(true);
    const body = {
      categoryId: selectedId || "",
    };
    try {
      const response = await deleteCategory(body).unwrap();
      setIsLoading(false);

      if (response?.statusCode === 200) {
        showToast("Category Deleted successfully");
        getAllCategory();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setIsLoading(false);
    }
  };

  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      isBlocked: status,
      categoryId: id,
    };

    try {
      const response = await updateStatus(body).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = category?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              isBlocked: status,
            };
          }
          return item;
        });
        setCategory(updatedData);
        if (status === true) {
          showToast("Category deactivated successfully");
        } else {
          showToast("Category activated successfully");
        }
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getAllCategory();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <Loader isLoading={isLoading} />
      <div className="main_title">
        <h1>Manage Categories</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Categories
        </p>
      </div>

      <div className="cards">
        {isView && (
          <CategoryTopbar
            setOpen={setOpen}
            setSelectedId={setSelectedId}
            setSelectedName={setCategoryName}
            setError={setError}
            setSearchTerm={setSearchTerm}
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            searchTerm={searchTerm}
          />
        )}
        {isView && (
          <CategoryList
            rows={category}
            setOpen={setOpen}
            setSelectedId={setSelectedId}
            setSelectedName={setCategoryName}
            setOpenDelete={setOpenDelete}
            handleStatusUpdate={handleStatusUpdate}
            loading={isLoading}
            page={page}
            count={count}
            setPage={setPage}
          />
        )}
      </div>
      <AddCategory
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        handleSubmit={handleSubmit}
        categoryName={categoryName}
        setCategoryName={setCategoryName}
        error={error}
        selectedId={selectedId}
      />
      <ConfirmationModal
        text="Are you sure to delete this category"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </MainContainer>
  );
};

export default ManageCategories;
